export default function Estados() {
  return (
    <div style={{ padding: 24 }}>
      <h2>Gestión de Estados</h2>
      <p>Define los estados (disponible, pausa, capacitación, etc.) y configúralos.</p>
    </div>
  );
}
